import { useContext } from 'react'
import { RemoteConfigContext } from 'lib/remoteConfig/RemoteConfigContext'
import { useStore } from 'state/store'
import Tenants from 'views/Tenants'
import ComingSoon from 'views/ComingSoon'
import Loading from 'components/Loading'

const TenantsContainer = () => {
  const workspaceId = useStore(state => state.workspace.id)
  const organizationId = useStore(state => state.organization.id)
  const { getBoolean, configLoaded } = useContext(RemoteConfigContext)
  const companiesEnabled = getBoolean('hera_workspace_companies_enabled')

  if (!configLoaded || !workspaceId || !organizationId) {
    return <Loading />
  }

  if (companiesEnabled) {
    return <Tenants organizationId={organizationId} workspaceId={workspaceId} />
  }

  return (
    <ComingSoon
      title="pmportal.companies.title"
      description="pmportal.companies.description"
    />
  )
}

export default TenantsContainer
